import React, { useEffect, useState } from 'react';
//import { renderCount } from '../../../../appHelpers/appLoggers';
import styled from 'styled-components';
import { IconButton, Form, Modal, Button, SelectPicker, Divider, Message, InputNumber, useToaster, Input, CheckPicker } from 'rsuite';
import { useAuth0 } from '@auth0/auth0-react';
import AddOutlineIcon from '@rsuite/icons/AddOutline';
import axiosInstance from '../../../../../appHelpers/axiosInstance';

export const LogAddAlertFC = ({dataConfig, sme, metadata, refresh}) => {
   const { getAccessTokenSilently } = useAuth0();
   const toaster = useToaster();
   const initFormSite = {
      user_id: '',
      system_id: sme,
      field_name: '',
      field_name_alias: '',
      field_name_multi: [],
      operator: '',
      threshold: '',
      threshold_two: '',
      severity: '',
   } 
   const fieldSelector = dataConfig?.map(column => ({label: column[1], value: column[0]}));
   const [operatorSelector, setOperatorSelector] = useState(['contains', 'offline'].map(operator => ({label: operator, value: operator})));
   const severitySelector = ['high', 'medium'].map(operator => ({label: operator, value: operator}));
   const handleOpen = () => setOpen(true);
   const handleClose = () => setOpen(false);
   const [open, setOpen] = useState(false);
   const [disable, setDisable] = useState(true);
   const [formValue, setFormValue] = useState(initFormSite);
   const message = (
      <Message showIcon type="success" header="Success">
         You successfully added an alert to: {sme}
      </Message>
   );

   const handleEnable = () => {
      if (formValue.operator === 'contains' && formValue.field_name && formValue.field_name_alias && formValue.threshold && formValue.severity) {
         setDisable(false);
      } else if (formValue.operator === 'composite_equals' && formValue.field_name_multi.length === 2 && formValue.field_name_alias && formValue.threshold && formValue.threshold_two && formValue.severity) {
         setDisable(false);
      } else if (formValue.operator === 'offline' && formValue.threshold && formValue.severity)  {
         let tempFormValue = formValue
         tempFormValue.field_name = 'capture_datetime'
         setFormValue(tempFormValue);
         setDisable(false);
      } else {
         setDisable(true);
      }
   }

   const handleCheckPickerChange = (value) => {
      // Check if the number of selected options exceeds the maximum limit
      if(value.field_name_multi?.length > 2 && value.field_name_multi.length !== 0) {
         const restrictMessage = (<Message showIcon type="error" header="Error">
            You can only choose two columns.
         </Message>)
         value.field_name_multi = value.field_name_multi.slice(0,2);
         toaster.push(restrictMessage,'topCenter');
         setFormValue(value);
      } else {
         setFormValue(value);
      }
    };

   const onSubmit = async () => {
      try {
         const token = await getAccessTokenSilently({ audience: `${process.env.REACT_APP_AUTH0_EXPRESS_API}` });

         const res = await axiosInstance({
            method: 'POST',
            url: `/alert/log/models/${sme}`,
            headers: { 
               'Content-Type': 'application/json',
               authorization: `Bearer ${token}`,
               },
            data:  JSON.stringify({
               model: formValue,
               metadata: metadata
            }),
         });
         // setResMsg(response.data);
         toaster.push(message,'topCenter');
         refresh();
         handleClose();
      } catch (error) {
         console.error(error);
         toaster.push(errMessage,'topCenter');
      }
   }
   
   const updateOperator = () => {
      if(metadata.manufacturer?.toUpperCase() === 'SIEMENS' && (metadata.modality?.toUpperCase() === 'CT' || metadata.modality?.toUpperCase() === 'CV/IR')) {
         setOperatorSelector(['composite_equals', 'offline'].map(operator => ({label: operator, value: operator})));
      }
   }

   useEffect(() => {
      updateOperator();
   }, []);

   useEffect(() => {
      handleEnable();
   }, [formValue]);
   return (
      <AddAlertSC>
         <IconButton icon={<AddOutlineIcon />} onClick={handleOpen}> Add Default Alert </IconButton>
         <Modal
            size="xs"
            open={open}
            onClose={handleClose}
         >
            <Modal.Header>
               <Modal.Title>Add Alert To: {sme}</Modal.Title>
            </Modal.Header>
            <Divider/>
            <PreviewHeader>
               {formValue.severity ? 
                  <SeverityHeader severity={formValue.severity}><b>{formValue.severity?.toUpperCase()} SEVERITY ALERT </b> </SeverityHeader>
                  : null
               }
               {formValue.field_name_alias ?
                  formValue.field_name_alias
                  : null
               } 
            </PreviewHeader>
               
            {formValue.operator && formValue.operator === 'contains' ? 
               <div style={{paddingTop: '2.5%'}}>
                  <b>Triggered When: </b> The [<b>{dataConfig.filter(config => config[0] === formValue.field_name).map(column => column[1])}</b>] column contains <b>{formValue.threshold}</b>
                  
               </div>
               : formValue.operator && formValue.operator === 'composite_equals' ?
                  <div style={{paddingTop: '2.5%'}}>
                     <b>Triggered When: </b> <br/> 
                     {dataConfig.filter(config => formValue.field_name_multi[0] === config[0]).map(column => <div><b>[{column[1]}]</b> column equals <b>{formValue.threshold}</b></div>)}
                     AND
                     {dataConfig.filter(config => formValue.field_name_multi[1] === config[0]).map(column => <div><b>[{column[1]}]</b> column equals <b>{formValue.threshold_two}</b></div>)}
                  </div>
               : formValue.operator && formValue.operator === 'offline' ?
               <div style={{paddingTop: '2.5%'}}>
                  <b>Triggered When: </b> <br/> 
                  <>System has been offline for atleast: {formValue.threshold ? formValue.threshold : '-'} hours.</>
               </div>
               : null
            }
            <br/>
           
            <Divider/>
            <Modal.Body>
               <Form fluid
                  formValue={formValue}
                  onChange={formValue => handleCheckPickerChange(formValue)}
               >
                  <Form.Group controlId="severity">
                     <Form.ControlLabel>Severity</Form.ControlLabel>
                     <Form.Control name="severity" accepter={SelectPicker} data={severitySelector} searchable={false} block/>
                  </Form.Group>

                  {formValue.operator === 'contains' || formValue.operator === 'composite_equals' ? 
                     <Form.Group controlId="field_name_alias">
                        <Form.ControlLabel>Message</Form.ControlLabel>
                        <Form.Control name="field_name_alias" accepter={Input}  block/>
                     </Form.Group>
                  : null
                  }

                  <Form.Group controlId="operator">
                     <Form.ControlLabel>Operator</Form.ControlLabel>
                     <Form.Control name="operator" accepter={SelectPicker} data={operatorSelector} searchable={false} block/>
                  </Form.Group>

                  {/* Change Selector Type for Column When Operator Changes */}
                  {formValue.operator === 'contains' ? 
                     
                     <Form.Group controlId="field_name">
                        <Form.ControlLabel>Column</Form.ControlLabel>
                        <Form.Control name="field_name" accepter={SelectPicker} data={fieldSelector} searchable={false} block/>
                     </Form.Group>
                     : formValue.operator === 'composite_equals' ?
                     <Form.Group controlId="field_name_multi">
                        <Form.ControlLabel>Column</Form.ControlLabel>
                        <Form.Control name="field_name_multi" accepter={CheckPicker} data={fieldSelector} searchable={false} block/>
                     </Form.Group>
                     : null
                  }

                  {formValue.operator === 'offline' ? 
                     <>
                        <Form.Group controlId="threshold">
                           <Form.ControlLabel>Threshold for Hours Offline:</Form.ControlLabel>
                           <Form.Control name="threshold" accepter={InputNumber} min={1} max={168} block/>
                        </Form.Group>
                     </>
                     : null
                  }

                  {formValue.operator === 'contains' ?  
                     <Form.Group controlId="threshold">
                        <Form.ControlLabel>Threshold for: <b>{dataConfig.filter(config => config[0] === formValue.field_name).map(column => column[1])}</b> column.</Form.ControlLabel>
                        <Form.Control name="threshold" accepter={Input} block/>
                     </Form.Group>
                  : formValue.operator === 'composite_equals' ?
                  <>
                     {formValue.field_name_multi[0] ? 
                        <Form.Group controlId="threshold">
                           <Form.ControlLabel>Threshold for: <b>{dataConfig.filter(config => config[0] === formValue.field_name_multi[0]).map(column => column[1])}</b> column.</Form.ControlLabel>
                           <Form.Control name="threshold" accepter={Input} block/>
                        </Form.Group>
                     : null
                     }
                     {formValue.field_name_multi[1] ? 
                        <Form.Group controlId="threshold_two">
                           <Form.ControlLabel>Threshold for: <b>{dataConfig.filter(config => config[0] === formValue.field_name_multi[1]).map(column => column[1])}</b> column.</Form.ControlLabel>
                           <Form.Control name="threshold_two" accepter={Input} block/>
                        </Form.Group>
                     : null
                     }                     
                  </>
                  : null
                  }       
               </Form>            
            </Modal.Body>

            <Modal.Footer>
               <Button appearance="primary" onClick={onSubmit} disabled={disable}>
                  Submit
               </Button>
               <Button onClick={handleClose} appearance="subtle">
                  Cancel
               </Button>
            </Modal.Footer>         
         </Modal>      
      </AddAlertSC>
   )
};

const AddAlertSC  = styled.div`
   display: inline-block;
   padding: 1%;
`

const PreviewHeader  = styled.div`
   color: rgb(0, 91, 148);
   background-color: rgb(243, 248, 252);
   display: block;
   text-align: center;
`

const errMessage = (
   <Message showIcon type="error" header="Error">
      Something went wrong. Please try again.
   </Message>
);

const SeverityHeader = styled.div`
   padding: 1%;
   border-radius: 5px;
   color: ${({ severity }) =>  severity === 'high' ? '#e51b1d;' 
                             : severity === 'medium' ?  '#fda005'
                             : severity === 'low' ? 'darkgrey'
                             : 'white'};
   background-color: ${({ severity }) =>  severity === 'high' ? '#fff2f2;' 
                              : severity === 'medium' ?  '#ffeecc'
                              : severity === 'low' ? '#e6e5e3'
                              : 'green'};
`;

